var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6.5,
    width: 2,
    height: 2,
    fill: "white",
    stroke: "#626262"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 0.5,
    width: 2,
    height: 2,
    fill: "#626262",
    stroke: "#626262"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 2.08577,
    width: 2,
    height: 2,
    transform: "rotate(45 11.5 2.08577)",
    fill: "#626262",
    stroke: "#626262"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.0858,
    y: 3.5,
    width: 2,
    height: 2,
    transform: "rotate(-45 2.0858 3.5)",
    fill: "#626262",
    stroke: "#626262"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 6.5,
    width: 2,
    height: 2,
    fill: "#626262",
    stroke: "#626262"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10.0858,
    width: 2,
    height: 2,
    transform: "rotate(45 11.5 10.0858)",
    fill: "#626262",
    stroke: "#626262"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 12.5,
    width: 2,
    height: 2,
    fill: "#626262",
    stroke: "#626262"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.25,
    y: 7.25,
    width: 0.5,
    height: 0.5,
    fill: "white",
    stroke: "#626262",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate);
export default __webpack_public_path__ + "static/media/rotate.12c64cdf212a2d7ece40c3c8875bf000.svg";
export { ForwardRef as ReactComponent };